import CardImage from "components/Card/CardImage";
import {  NumberWithFirstDecimal } from "utils";
import "./index.css";
import "../../Instructors/components/instructorInformation/index.css";
import { imagePath } from "utils/assetHelper";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import EpisodeBookSession from "./EpisodeBookSession";

const EpisodesDescription = (props) => {
  const {
    author,
    designation,
    instructorThumbnail,
    items,
    handleCurrentAuthor,
  } = props;
  const { instructorDetails } = useSelector((state) => state?.instructor);
  const instructorInfo = instructorDetails?.[0];

  const history = useHistory();
  const dispatch = useDispatch();

  const handleRedirectToInstructorDetails = () => {
    history.push(`/instructor-details/${items?.id}`);
  };

  useEffect(() => {
    if (items?.id && items?.availableForSession) {
      dispatch?.instructor?.getInstructorDetails(items?.id);
    }
  }, [items?.availableForSession]);

  return (
    <div>
      <div className="flex items-center justify-between gap-1 my-5 px-[0.6rem] py-[0.6rem] rounded-xl bg-secondary">
        <div className="flex items-center gap-3">
          <div className="instructor__profile">
            <CardImage src={instructorThumbnail} />
          </div>
          <div className="flex flex-col sm:flex-row sm:gap-10 items-start sm:items-center">
            <div
              onClick={() => handleCurrentAuthor(items)}
              className="cursor-pointer  w-32 sm:w-48 md:w-72"
            >
              <h1 className="text-white truncate text-[15px] sm:text-2xl font-bold">
                {author}
              </h1>
              <h2 className="text-greeny truncate-text text-[12px] sm:text-[14px] font-normal sm:font-bold">
                {designation}
              </h2>
            </div>
            <div className="flex gap-2 sm:gap-5">
              {items?.rating > 0 &&(
                <div className=" flex sm:flex-col items-center gap-1 sm:gap-0 ">
                <span className="items-center text-white flex rating-experience sm:text-[16px] sm:font-bold text-[8px] gap-1">
                  <CardImage
                    className="m-auto w-2 sm:w-4"
                    src={imagePath("/star2.svg")}
                  />
                  {NumberWithFirstDecimal(items?.rating)}
                </span>
                <span className="rating-experience text-[8px]  sm:text-[16px] sm:font-bold text-white">
                  Ratings
                </span>
              </div>
              )}
              {items?.experienceYears > 0 &&(
                <div className="flex sm:flex-col items-center  text-center sm:gap-0   gap-1">
                <span className="items-center flex text-white rating-experience sm:text-[16px] sm:font-bold text-[8px] gap-1">
                  <CardImage
                    className="m-auto w-2 sm:w-4"
                    src={imagePath("/briefcase.svg")}
                  />
                  {items?.experienceYears} yrs
                </span>
                <span className="rating-experience text-[8px]  sm:text-[16px] sm:font-bold text-white">
                  Experience
                </span>
              </div>
              )}
            </div>
          </div>
        </div>
        {items?.availableForSession && (
          <EpisodeBookSession handleRedirectToInstructorDetails={handleRedirectToInstructorDetails} instructorInfo={instructorInfo}/>
        )}
      </div>
    </div>
  );
};

export default EpisodesDescription;
